export enum DrinkerTypes {
  MONTHLY = "monthly",
  NEVER = "never",
  THREEDAYSORLESS = "3minusdays",
  FOURDAYSORMORE = "4plusdays"
}
